module.exports = __webpack_public_path__ + "media/images/icons/country_flags/kr-cb52920205a3904b12e951c41a680672.svg";